var F = Object.defineProperty;
var B = (a, e, t) => e in a ? F(a, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : a[e] = t;
var g = (a, e, t) => B(a, typeof e != "symbol" ? e + "" : e, t);
import { logger as o } from "@pufflig/logger";
import { safeStringify as R, shortUID as M } from "@pufflig/prompt-tools";
import * as H from "papaparse";
import * as $ from "@duckdb/duckdb-wasm";
import x from "@duckdb/duckdb-wasm/dist/duckdb-browser-eh.worker.js?url";
import k from "@duckdb/duckdb-wasm/dist/duckdb-browser-mvp.worker.js?url";
import q from "@duckdb/duckdb-wasm/dist/duckdb-eh.wasm?url";
import v from "@duckdb/duckdb-wasm/dist/duckdb-mvp.wasm?url";
const N = (a) => a.replace(/[^a-zA-Z0-9_]/g, "_").replace(/^([0-9])/, "_$1");
function W(a) {
  return a.trim().replace(/[\n\r\t\?\"\'\`\[\]\(\)\{\}\\\|]/g, "").replace(/[^a-zA-Z0-9_]/g, "_").replace(/^([0-9])/, "_$1");
}
async function U(a) {
  const e = a.match(/\r\n|\n|\r/);
  if (!e)
    throw new Error("CSV file is empty or improperly formatted");
  const t = e[0], r = a.indexOf(t), n = a.substring(0, r), s = a.substring(r), i = H.parse(n, {
    preview: 1,
    skipEmptyLines: !1
  });
  if (!i.data || !i.data[0])
    throw new Error("CSV header row is empty or improperly formatted");
  const l = i.data[0].map(W), T = i.meta.delimiter || ",";
  return l.join(T) + s;
}
const E = class E {
  constructor(e, t) {
    g(this, "conn");
    g(this, "db");
    this.conn = e, this.db = t;
  }
  static getInstance(e, t) {
    return E.instance || (E.instance = new E(e, t)), E.instance;
  }
  /**
   * Run an SQL query against the database.
   *
   * @param query
   * @returns
   */
  async query(e) {
    try {
      return o.debug(`(DB) Executing query: ${e}`), { success: (await this.conn.query(e)).toArray() };
    } catch (t) {
      return o.debug(`(DB) Query error: ${t}`), { success: null, error: t.message };
    }
  }
  /**
   * Create a table from a file (CSV or JSON).
   *
   * @param tableName
   * @param file
   * @returns
   */
  async createTableFromFile(e, t, r = "main") {
    const n = N(e);
    try {
      if (o.debug(`(DB) Creating table from file: ${e}, file type: ${t.type}`), r !== "main" && await this.conn.query(`CREATE SCHEMA IF NOT EXISTS "${r}";`), t.type === "text/csv") {
        const s = await t.text(), i = await U(s);
        return await this.db.registerFileText(`${t.name}.csv`, i), await this.conn.insertCSVFromPath(`${t.name}.csv`, {
          name: n,
          detect: !0,
          schema: r
        }), { success: { tableName: `${r}.${n}` } };
      }
      return t.type === "application/json" ? (await this.db.registerFileText(`${t.name}.json`, await t.text()), await this.conn.insertJSONFromPath(`${t.name}.json`, { name: n, schema: r }), { success: { tableName: `${r}.${n}` } }) : { success: null, error: "Invalid file type" };
    } catch (s) {
      try {
        if (JSON.parse(s.message).error_subtype === "ENTRY_ALREADY_EXISTS")
          return o.debug(`(DB) Table ${n} already exists, skipping creation.`), { success: { tableName: `${r}.${n}` } };
      } finally {
        return o.error(`(DB) Error creating table from file: ${s.message}`), { success: null, error: s.message };
      }
    }
  }
  /**
   * Create a table from result.
   *
   * @param tableName
   * @param file
   * @returns
   */
  async createTableFromResult(e, t = "main") {
    const r = e.metadata.resultId, n = e.table, s = new File([R(n)], `${r}.json`, { type: "application/json" });
    return this.createTableFromFile(r, s, t);
  }
  /**
   * Setup a list of tables from files into a schema.
   *
   * @param tableSchema
   * @returns
   */
  async setupTables(e, t, r = "main") {
    try {
      if (o.debug(`(DB) Setting up tables in schema: ${r}`), e.length !== t.length)
        return {
          success: null,
          error: "files[] and ids[] must have the same length"
        };
      r !== "main" && await this.conn.query(`CREATE SCHEMA IF NOT EXISTS "${r}";`);
      const n = [];
      for (const [s, i] of e.entries()) {
        const u = t[s], l = await this.createTableFromFile(u, i, r);
        if (!l.success) throw new Error(l.error);
        n.push(l.success.tableName);
      }
      return { success: { tableNames: n } };
    } catch (n) {
      return o.error(`(DB) Error setting up tables: ${n}`), { success: null, error: n.message };
    }
  }
  /**
   * Provides a detailed description of a table, including column statistics, sample values, and
   * (for string columns) up to three example values.
   *
   * @param tableName Fully‑qualified table name (e.g. "schema.my_table").
   * @returns Success envelope with the description, or an error message.
   */
  async describeTable(e) {
    var t;
    try {
      o.debug(`(DB) Describing table: ${e}`);
      let r;
      const [n, s] = e.split("."), i = (p) => typeof p == "bigint" ? Number(p) : p, l = (await this.conn.query(
        `SELECT column_name, data_type
           FROM information_schema.columns
          WHERE table_name = '${s}'`
      )).toArray(), T = [];
      for (const p of l) {
        const c = p.column_name, m = p.data_type.toUpperCase(), _ = await this.conn.query(
          `SELECT COUNT(*) AS null_count
             FROM ${e}
            WHERE "${c}" IS NULL`
        ), I = i(_.toArray()[0].null_count) > 0, d = {};
        if (m.includes("INT") || m.includes("DECIMAL") || m.includes("FLOAT")) {
          const y = await this.conn.query(
            `SELECT MIN("${c}")  AS min_val,
                    MAX("${c}")  AS max_val,
                    AVG("${c}")  AS mean_val,
                    PERCENTILE_CONT(0.5) WITHIN GROUP (ORDER BY "${c}") AS median_val
               FROM ${e}
              WHERE "${c}" IS NOT NULL`
          ), [b] = y.toArray();
          d.min = i(b.min_val), d.max = i(b.max_val), d.mean = i(b.mean_val), d.median = i(b.median_val);
        } else if (m.includes("DATE") || m.includes("TIMESTAMP")) {
          const y = await this.conn.query(
            `SELECT strftime('%Y-%m-%d %H:%M:%S', MIN("${c}")) AS start_date,
                    strftime('%Y-%m-%d %H:%M:%S', MAX("${c}")) AS end_date
               FROM ${e}
              WHERE "${c}" IS NOT NULL`
          ), [b] = y.toArray();
          d.startDateTime = b.start_date, d.endDateTime = b.end_date;
        } else if (m.includes("CHAR") || m.includes("TEXT") || m.includes("VARCHAR")) {
          const { distinct_count: y } = (await this.conn.query(
            `SELECT COUNT(DISTINCT "${c}") AS distinct_count
               FROM ${e}
              WHERE "${c}" IS NOT NULL`
          )).toArray()[0];
          if (y < 100) {
            const w = await this.conn.query(
              `SELECT DISTINCT "${c}"
                 FROM ${e}
                WHERE "${c}" IS NOT NULL
                LIMIT 100`
            );
            d.categories = w.toArray().map((O) => String(O[c]));
          }
          r = (await this.conn.query(
            `SELECT "${c}"
               FROM ${e}
              WHERE "${c}" IS NOT NULL
              GROUP BY "${c}"
              ORDER BY RANDOM()
              LIMIT 10`
          )).toArray().map((w) => String(w[c]));
        }
        const C = {
          columnName: c,
          dataType: m,
          hasNulls: I,
          ...d,
          ...!d.categories && r && r.length > 0 ? { exampleValues: r } : {},
          isPrimaryKey: !1,
          isForeignKey: !1
        };
        r = void 0;
        const L = Object.fromEntries(
          Object.entries(C).filter(([, y]) => y != null)
        );
        T.push(L);
      }
      const [{ count: A }] = (await this.conn.query(`SELECT COUNT(*) AS count FROM ${e}`)).toArray(), D = ((t = (await this.conn.query(
        `SELECT table_comment
           FROM information_schema.tables
          WHERE table_name = '${s}'`
      )).toArray()[0]) == null ? void 0 : t.table_comment) ?? "";
      return { success: {
        tableName: s,
        numRows: i(A),
        columns: T,
        ...D && { tableDescription: D }
      } };
    } catch (r) {
      return o.error(`(DB) Error describing table: ${r}`), { success: null, error: r.message };
    }
  }
  /**
   * Describe an array of objects as a table schema.
   *
   * @param arr
   * @returns
   */
  async describeArray(e, t) {
    var r, n;
    try {
      const s = N(M());
      await this.conn.query(`CREATE SCHEMA IF NOT EXISTS "${s}";`);
      const i = new File([R(t)], `${e}.json`, { type: "application/json" }), u = await this.createTableFromFile(e, i, s);
      if (o.debug(`(DB) describe array: ${(r = u.success) == null ? void 0 : r.tableName}`), u.error || !((n = u.success) != null && n.tableName))
        return { success: null, error: u.error || "Failed to create table from array" };
      const l = await this.describeTable(u.success.tableName);
      return await this.dropTable(u.success.tableName), l.error ? { success: null, error: l.error } : { success: l.success };
    } catch (s) {
      return o.error("(DB) Error describing array:", s), { success: null, error: s.message };
    }
  }
  /**
   * Clear all tables in the database.
   *
   * @param schema Optional schema name to clear tables from. If not provided, defaults to the main schema.
   * @returns
   */
  async clearTables(e = "main") {
    try {
      o.debug(`(DB) Clearing all tables in schema: ${e}`);
      const r = (await this.conn.query(`
      SELECT table_name
      FROM   information_schema.tables
      WHERE  table_schema = '${e}'
        AND  table_type   = 'BASE TABLE';`)).toArray();
      o.debug(`(DB) Found ${r.length} tables in schema "${e}"`);
      for (const { table_name: n } of r)
        await this.conn.query(`DROP TABLE IF EXISTS "${e}"."${n}" CASCADE;`);
      return { success: !0 };
    } catch (t) {
      return o.error("(DB) Error clearing tables:", t), { success: null, error: t.message };
    }
  }
  /**
   * Drop a table given its name.
   *
   * @param tableName Fully‑qualified table name (e.g. "schema.my_table").
   * @returns
   */
  async dropTable(e) {
    try {
      return await this.conn.query(`DROP TABLE ${e};`), { success: !0 };
    } catch (t) {
      return { success: null, error: t.message };
    }
  }
};
g(E, "instance", null);
let f = E;
const j = {
  mvp: {
    mainModule: v,
    mainWorker: k
  },
  eh: {
    mainModule: q,
    mainWorker: x
  }
};
let h = null, S = null;
const z = async () => {
  if (h && S)
    return { conn: h, db: S };
  const a = await $.selectBundle(j), e = new Worker(a.mainWorker), t = new $.ConsoleLogger($.LogLevel.ERROR), r = new $.AsyncDuckDB(t, e);
  await r.instantiate(a.mainModule, a.pthreadWorker);
  const n = await r.connect();
  return h = n, S = r, { conn: n, db: r };
}, ee = async () => {
  o.debug("(DB) Initializing DuckDB instance...");
  const { conn: a, db: e } = await z();
  return o.debug("(DB) DuckDB instance initialized successfully."), f.getInstance(a, e);
};
export {
  f as SQLDatabase,
  ee as initDB
};
//# sourceMappingURL=index.js.map
